import { useEffect, useRef, useState } from 'react';
import './AppTopHeader.css';

type AppTopHeaderProps = {
  onMobileMenuClick: () => void;
  platformName?: string;
  hiddenOffset?: number;
};

export function AppTopHeader({
  onMobileMenuClick,
  platformName = 'Aftrad',
  hiddenOffset = 0,
}: AppTopHeaderProps) {
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const mobileDropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (!mobileDropdownRef.current?.contains(event.target as Node)) {
        setIsMobileDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  return (
    <header
      className="app-top-header"
      aria-label="Barra superior"
      style={{
        marginBottom: `${-hiddenOffset}px`,
        transform: `translateY(-${hiddenOffset}px)`,
      }}
    >
      <div className="app-top-header-left">
        <button
          type="button"
          className="app-top-mobile-menu-trigger"
          aria-label="Abrir menú"
          onClick={onMobileMenuClick}
        >
          <span className="material-icons" aria-hidden="true">
            menu
          </span>
        </button>
      </div>

      <div className="app-top-mobile-brand">{platformName}</div>

      <div className="app-top-header-right app-top-header-right-desktop">
        <a className="app-top-link" href="#help">
          Help
        </a>

        <span className="app-top-icon" aria-hidden="true">
          ☁️
        </span>

        <div className="app-top-notification" aria-label="Notificaciones">
          <span className="material-icons app-top-bell-icon" aria-hidden="true">
            notifications
          </span>
          <span className="app-top-badge">9+</span>
        </div>

        <div className="app-top-plan">My pricing plan</div>

        <div className="app-top-time">
          <div className="app-top-time-value">10:02 AM (UTC+0)</div>
          <div className="app-top-time-sub">Session timezone</div>
        </div>
      </div>

      <div className="app-top-mobile-actions" ref={mobileDropdownRef}>
        <button
          type="button"
          className="app-top-mobile-actions-trigger"
          aria-label="Más opciones"
          onClick={() => setIsMobileDropdownOpen((prev) => !prev)}
        >
          <span className="material-icons" aria-hidden="true">
            more_vert
          </span>
        </button>

        {isMobileDropdownOpen && (
          <div className="app-top-mobile-dropdown">
            <a className="app-top-link" href="#help">
              Help
            </a>
            <div className="app-top-notification" aria-label="Notificaciones">
              <span className="material-icons app-top-bell-icon" aria-hidden="true">
                notifications
              </span>
              <span className="app-top-badge">9+</span>
            </div>
            <div className="app-top-plan">My pricing plan</div>
            <div className="app-top-time">
              <div className="app-top-time-value">10:02 AM (UTC+0)</div>
              <div className="app-top-time-sub">Session timezone</div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

